module.exports = __webpack_public_path__ + "static/media/files-icon.3ab98079.svg";